import { Result } from '~/core/results/types/results.type';

export const getResultContent = (result: Result): string => {
    if (result.content) {
        return result.content;
    }
    return '';
};
